import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private http: HttpClient) { }

  public DismissIncident(data: any) {    
    return this.http.post<any>(`${environment.apiUrl}/PushNotification/DismissTransferRequest`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  public GetIncidentDataNotificationAlertPanel(data: any) {    
    return this.http.post<any>(`${environment.apiUrl}/PushNotification/GetVehicleAndStaffTransferForNotificationAlertPanel`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  public Save(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/LandingPage/UpdateLandingPage`, data)
      .pipe(map(user => {
        return user;
      }));
  }
}
